module.exports = __webpack_public_path__ + "img/product_logo.b2893c45.png";